export const apiRoot = "/api/";
export const clientRoot = "https://autoresuma.netlify.app/";
